"use client";
import * as React$1 from "react";
//#region src/routerContext.tsx
var routerContext = React$1.createContext(null);
//#endregion
export { routerContext };

//# sourceMappingURL=routerContext.js.map